import React from "react"
import Snackbar from "@material-ui/core/Snackbar"
import Alert from "@material-ui/lab/Alert"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
  }
}))

const CustomizedSnackbars = (props) => {
  const classes = useStyles()
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    props.setSnack(false,props.snackState.typeMsg,'')
  }

  return (
    <div className={classes.root}>
        <Snackbar
          open={props.snackState.isShow}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert
            elevation={6}
            variant="filled"
            onClose={handleClose}
            color={props.snackState.typeMsg}
            severity={props.snackState.typeMsg}
          >
            {props.snackState.msg}
          </Alert>
        </Snackbar>
    </div>
  )
}

export default CustomizedSnackbars